import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WhatsAppTip.css';

/**
 * WhatsAppTip — shows contextual WhatsApp message formats after a key action.
 *
 * Props:
 *   title             — heading text (e.g. "✅ WEIGHT-0007 created")
 *   tips              — array of { label: string, message: string }
 *   onDismiss         — called after the fade-out completes
 *
 * Team notifications for new lots and lists are sent by the API on creation.
 */
const WhatsAppTip = ({ title, tips, onDismiss }) => {
  const { t } = useTranslation();
  const [copied,       setCopied]       = useState(null);
  const [fading,       setFading]       = useState(false);

  const handleCopy = (msg, idx) => {
    navigator.clipboard?.writeText(msg).then(() => {
      setCopied(idx);
      setTimeout(() => setCopied(null), 1500);
    });
  };

  const handleDismiss = () => {
    setFading(true);
    setTimeout(() => onDismiss?.(), 300);
  };

  if (!tips || tips.length === 0) return null;

  return (
    <div className={`wat-container${fading ? ' wat-fading' : ''}`}>
      <div className="wat-bar" />
      <div className="wat-inner">
        <div className="wat-header">
          <span className="wat-title">{title}</span>
          <button className="wat-close" onClick={handleDismiss} aria-label="Dismiss">×</button>
        </div>
        <div className="wat-subtitle">{t('wat_send_via_whatsapp')}</div>
        <div className="wat-tips">
          {tips.map((tip, i) => (
            <div key={i} className="wat-row">
              <span className="wat-tip-label">{tip.label}</span>
              <code className="wat-code">{tip.message}</code>
              <button
                className={`wat-copy${copied === i ? ' wat-copied' : ''}`}
                onClick={() => handleCopy(tip.message, i)}
                title={t('wat_copy')}
              >
                {copied === i ? '✓' : '⧉'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatsAppTip;
